export default __webpack_public_path__ + "media/titles/title_3_locale_nb-035ed02f.png";